import {
  InputAdornment,
  TextField,
  Tooltip,
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import React, { useState } from "react";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useSnackbar } from "notistack";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import CloseIcon from "@mui/icons-material/Close";
import { get_root_value } from "src/utils/domUtils";
import PaceCalculator from "src/pages/Calender/component/PaceCalculator";
import {
  exercise_history,
  exercise_obj,
  getOptionsByValue,
  paceFromVdot,
  select_obj_exercise,
  super_set_item,
  handle_change_parameters,
  formatWithLeadingZeros,
} from "src/utils/constant";
import CustomPopoverSection from "src/components/MenuOption/CustomPopoverSection";
import { programme_workout_exercise_history_list_api } from "src/DAL/programmeWorkout/programmeWorkout";
import { useContentSetting } from "src/Hooks/ContentSettingState";
import { makeStyles } from "@mui/styles";
import CustomFeilds from "./CustomFeilds";
import ModalsManager from "./ModalsManager";

const findPaceObjectByVdot = (vdotValue) => {
  return paceFromVdot.find((paceObject) => paceObject.vdot == vdotValue);
};

const useStyles = makeStyles(() => ({
  loading2: {
    position: "absolute",
    top: "50%",
    right: "50%",
    zIndex: 1000,
  },
}));

const EMOMExercisesUI = ({
  handleAdd,
  memueOptions,
  handleDelete,
  addArray,
  setaddArray,
  setModalChangeExe,
  isHistory,
  memberId,
  mainindex,
  member_vdot,
  member_vdot_info,
  isWithHistoryAndBigScreen,
  isSidebar,
}) => {
  const {
    setUserExerciseHistory,
    setUserExerciseHistoryLoading,
    selectedExercise,
    setSelectedExercise,
  } = useContentSetting();
  const vdotwholeObject = findPaceObjectByVdot(member_vdot);
  const [exerInfo, setExsrInfo] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenForSuperset, setModalOpenForSuperset] = useState(false);
  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const [historyModalOpenSuperset, setHistoryModalOpenSuperset] =
    useState(false);
  const [historyModalData, setHistoryModalData] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [openSingleExerciseInfo, setOpenSingleExerciseInfo] = useState(false);
  const [singleExerciseInfo, setSingleExerciseInfo] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [openPaceAlert, setOpenPaceAlert] = useState(false);
  const [detailsData, setDetailsData] = useState("");
  const [exerIndex, setExerIndex] = useState("");
  const [outerIndex, setOuterIndex] = useState("");
  const [openDetails, setOpenDetails] = useState(false);
  const [isExerciseForSuperSet, setIsExerciseForSuperSet] = useState(false);
  const [isWithHistory, setIsWithHistory] = useState(false);
  const [paceModalOpen, setPaceModalOpen] = useState(false);
  const [memberVdotData, setMemberVdotDataData] = useState({
    distance: "",
    time_interval: 0,
    easy_long: "e_km",
    thre_shold: "t_km",
    interval: "i_400_m",
    pace: vdotwholeObject?.e_km_low || 0,
    paceUp: vdotwholeObject?.e_km_up || 0,
    pace1: vdotwholeObject?.t_km || 0,
    pace2: vdotwholeObject?.i_400_m || 0,
  });
  const classes = useStyles();
  let smallScreen = window.innerWidth <= 450;

  const getMinutesForEmom = () => {
    let min = 10;
    let sec = 0;
    const list = [...addArray];
    const rounds = list[mainindex].rounds;
    const moments = list[mainindex].emomSets.length;
    const interval = list[mainindex].time_interval;
    min = formatWithLeadingZeros(
      Math.floor((rounds * moments * interval) / 60),
    );
    sec = formatWithLeadingZeros((rounds * moments * interval) % 60);
    return `${
      Math.floor(interval / 60) +
      " " +
      ":" +
      formatWithLeadingZeros(interval % 60) +
      " " +
      "minute" +
      " " +
      "for" +
      " " +
      min +
      ":" +
      sec
    }`;
  };

  const getMinutesForInterval = (index) => {
    const list = [...addArray];
    const interval = list[mainindex].time_interval;
    if (interval <= 60) {
      return index + 1;
    }
    if (interval % 60 == 0) {
      return `${
        (interval / 60) * index +
        1 +
        " – " +
        ((interval / 60) * index + interval / 60)
      }`;
    }
    let startInterval = interval * index;
    let endtInterval = interval * index + interval;
    let startintervalText =
      interval * index
        ? Math.floor(startInterval / 60) +
          " " +
          ":" +
          formatWithLeadingZeros(startInterval % 60)
        : 0;
    let endIntervalText =
      Math.floor(endtInterval / 60) +
      " " +
      ":" +
      formatWithLeadingZeros(endtInterval % 60);

    return `${startintervalText + " – " + endIntervalText}`;
  };

  const handleAddInterval = (e) => {
    e.preventDefault();
    let list = addArray;
    list[mainindex].emomSets.push([]);
    setaddArray([...list]);
    setModalChangeExe(true);
  };

  const handleDeleteInterval = (mainindex, index) => {
    let list = addArray;
    list[mainindex]["emomSets"].splice(index, 1);
    setaddArray([...list]);
    setModalChangeExe(true);
  };

  const handleMinusSetCount = (index) => {
    const list = [...addArray];
    const name = "rounds";
    const value = parseInt(list[index].rounds) - 1;
    const targetValue = value === "" ? 1 : Math.max(1, parseInt(value, 10));
    list[index][name] = targetValue;
    setaddArray(list);
    setModalChangeExe(true);
  };

  const handleAddSetCount = (index) => {
    const list = [...addArray];
    const name = "rounds";
    const value = parseInt(list[index].rounds) + 1;
    const targetValue = value === "" ? 1 : Math.max(1, parseInt(value, 10));
    list[index][name] = targetValue;
    setaddArray(list);
    setModalChangeExe(true);
  };

  const handleMinutesChange = (e) => {
    const minutes = parseInt(e.target.value) || 0;
    const seconds = addArray[mainindex].time_interval % 60;
    updateIntervalTime(minutes, seconds);
  };

  const handleSecondsChange = (e) => {
    let seconds = parseInt(e.target.value) || 0;
    seconds = Math.min(Math.max(seconds, 0), 59);
    const minutes = Math.floor(addArray[mainindex].time_interval / 60);
    updateIntervalTime(minutes, seconds);
  };

  const updateIntervalTime = (minutes, seconds) => {
    const totalSeconds = minutes * 60 + seconds;
    const list = [...addArray];
    list[mainindex]["time_interval"] = totalSeconds;
    setaddArray(list);
  };

  const handleAddMoment = (outerIndex, inerIndex) => {
    let list = addArray;
    const lastIndex = list[mainindex].emomSets[outerIndex].length;
    list[mainindex].emomSets[outerIndex].splice(lastIndex, 0, {
      ...exercise_obj(member_vdot, vdotwholeObject),
    });
    setaddArray([...list]);
    setModalChangeExe(true);
  };

  const handleDeleteIntervalExercise = (index, exerIndex) => {
    let list = addArray;
    list[mainindex]["emomSets"][index].splice(exerIndex, 1);
    setaddArray([...list]);
    setModalChangeExe(true);
  };

  const handleArrowSuperSet = (value, index, exerIndex) => {
    const list = [...addArray];
    list[mainindex]["emomSets"][index][exerIndex]["open"] = value;
    setaddArray(list);
  };

  const handleChangeDes = (e, index) => {
    const { name, value } = e.target;

    const list = [...addArray];
    list[index][name] = value;

    setaddArray(list);
    setModalChangeExe(true);
  };

  const getVdotPace = (index, exerIndex, setIndex) => {
    const list = [...addArray];

    let value_type =
      list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex];
    if (!value_type["vdot"]) {
      return;
    }
    const vodt = value_type["vdot"];
    const distanceType = value_type["race_type"];
    const paceType = value_type["pace_type"];
    const vdot33Object = findPaceObjectByVdot(vodt);
    if (distanceType != "el") {
      value_type["pace"] = vdot33Object[paceType];
      if (!vdot33Object[paceType]) {
        memberId && setOpenPaceAlert(true);
      }
    } else {
      value_type["pace"] = vdot33Object[paceType + "_low"];
      value_type["paceUp"] = vdot33Object[paceType + "_up"];
    }

    setaddArray(list);
  };

  const handleChangeVdotPaceType = (e, index, exerIndex, setIndex) => {
    const { name, value } = e.target;
    const list = [...addArray];
    let value_type =
      list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex];
    value_type[name] = value;
    setaddArray(list);
    setModalChangeExe(true);
    getVdotPace(index, exerIndex, setIndex);
  };

  const handleChangeVdotDistance = (e, index, exerIndex, setIndex) => {
    const { name, value } = e.target;
    const list = [...addArray];
    let value_type =
      list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex];

    value_type[name] = value;

    const optionsTypeSArray = getOptionsByValue(value);
    value_type["optionsType"] = optionsTypeSArray;
    value_type["pace_type"] = optionsTypeSArray[0].key;

    setaddArray(list);
    setModalChangeExe(true);

    if (list[mainindex]["emomSets"][index]?.parameters?.includes("Vdot"))
      getVdotPace(index, exerIndex, setIndex);
  };

  const handleChangeEmomSet = (e, index, exerIndex, setIndex) => {
    const { name, value } = e.target;

    const list = [...addArray];
    list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex][name] =
      value;
    setaddArray(list);
    setModalChangeExe(true);
  };

  const handleChangeEmomSetTempo = (e, index, exerIndex, setIndex) => {
    const { name, value } = e.target;
    if (value.length <= 4) {
      const list = [...addArray];
      list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex][name] =
        value;
      setaddArray(list);
      setModalChangeExe(true);
    }
  };

  const handleRearageSetCount = (index, count) => {
    const list = [...addArray];
    const name = "superset_sets";
    const value = count;
    const targetValue = value === "" ? 1 : Math.max(1, parseInt(value, 10));
    list[index][name] = targetValue;
    list[index]?.superSet.forEach((superSetItem) => {
      const currentSetLength = superSetItem.set.length;
      if (currentSetLength < targetValue) {
        const objectsToAdd = targetValue - currentSetLength;

        for (let i = 0; i < objectsToAdd; i++) {
          superSetItem.set.push({
            ...super_set_item,
          });
        }
      } else if (currentSetLength > targetValue) {
        superSetItem.set.splice(targetValue);
      }
    });

    setaddArray(list);
    setModalChangeExe(true);
    setHistoryModalOpenSuperset(false);
  };

  const handleChangeUpMoment = (value) => {
    if (value == 0) {
      enqueueSnackbar("You are already on Top !", { variant: "info" });
      return;
    }
    const items = Array.from(addArray);
    const [reorderedItem] = items[mainindex]["emomSets"][value?.index].splice(
      value?.exerIndex,
      1,
    );
    items[mainindex]["emomSets"][value?.index].splice(
      value?.exerIndex - 1,
      0,
      reorderedItem,
    );

    setaddArray(items);
    setModalChangeExe(true);
  };

  const handleChangeDownMoment = (value) => {
    if (value >= addArray.length - 1) {
      enqueueSnackbar("You are already on Bottom !", { variant: "info" });
      return;
    }
    const items = Array.from(addArray);
    const [reorderedItem] = items[mainindex]["emomSets"][value?.index].splice(
      value?.exerIndex,
      1,
    );
    items[mainindex]["emomSets"][value?.index].splice(
      value?.exerIndex + 1,
      0,
      reorderedItem,
    );

    setaddArray(items);
    setModalChangeExe(true);
  };

  const handleSupersetExerciseList = (mainIndex, exerInde, isWithHistory) => {
    setDetailsData(mainIndex);
    setExerIndex(exerInde);
    setIsExerciseForSuperSet(true);
    setIsWithHistory(isWithHistory);
  };

  const handleSelectExercise = (value) => {
    const list = [...addArray];
    if (list[detailsData]["exercise"]._id == value._id) {
      return;
    }
    list[detailsData]["exercise"] = value;
    list[detailsData]["description"] = value?.instructions;
    setaddArray(list);
    setModalChangeExe(false);
  };

  const handleCopyExercise = (value) => {
    const list = [...addArray];
    list[detailsData]["set"] = value.set;
    list[detailsData]["parameters"] = value?.parameters;
    setaddArray(list);
    setModalChangeExe(true);
    setHistoryModalOpen(false);
  };

  const handleCopySupersetExercise = (value) => {
    const list = [...addArray];
    list[detailsData]["superSet"][exerIndex]["set"] = value.set;
    list[detailsData]["superSet"][exerIndex]["parameters"] = value?.parameters;
    setaddArray(list);
    setModalChangeExe(true);
    handleRearageSetCount(detailsData, list[detailsData].superset_sets);
  };

  const handleHistoryOFAnExercise = async (
    value,
    mainindex,
    detailsData,
    exerIndex,
  ) => {
    let postData = {
      exercise: value?._id,
      member: memberId,
    };
    try {
      setUserExerciseHistoryLoading(true);
      let result = await programme_workout_exercise_history_list_api(postData);
      if (result.code == 200) {
        setSelectedExercise(value?._id);

        if (!result.exercise_history.length > 0) {
          setaddArray((prevArray) => {
            const updatedArray = [...prevArray];
            updatedArray[mainindex]["emomSets"][detailsData][exerIndex][
              "history"
            ] = [];
            return updatedArray;
          });
          return;
        }

        let givenExercise = result.exercise_history.map((item) => {
          return exercise_history(item);
        });
        setUserExerciseHistory(givenExercise);
        setaddArray((prevArray) => {
          const updatedArray = [...prevArray];
          updatedArray[mainindex]["emomSets"][detailsData][exerIndex][
            "history"
          ] = givenExercise;
          return updatedArray;
        });
      } else {
      }
    } catch (error) {
    } finally {
      setUserExerciseHistoryLoading(false);
    }
  };

  const handleSelectSupersetExercise = (values) => {
    const list = [...addArray];
    const emomSets = list[mainindex]?.emomSets || [];

    if (Array.isArray(values)) {
      const currentSets = emomSets[detailsData] || [];
      const updatedSets = currentSets.slice(0, exerIndex);

      values.forEach((exercise) => {
        const newExercise = select_obj_exercise(
          member_vdot,
          vdotwholeObject,
          exercise,
        );
        updatedSets.push(newExercise);
      });

      const remainingSets = currentSets.slice(exerIndex);
      emomSets[detailsData] = [...updatedSets, ...remainingSets];

      list[mainindex].emomSets = emomSets;

      const updatedList = list.map((item) => {
        return {
          ...item,
          emomSets: item.emomSets.map((setArray) => {
            return setArray.filter(
              (set) => set.exercise && Object.keys(set.exercise).length !== 0,
            );
          }),
        };
      });
      setaddArray(updatedList);
      setModalChangeExe(false);

      if (isWithHistoryAndBigScreen) {
        values.forEach((value, index) => {
          handleHistoryOFAnExercise(
            value,
            mainindex,
            detailsData,
            exerIndex + index,
          );
        });
      }
    }
  };

  const handleSelectSupersetExerciseSingle = (value) => {
    const list = [...addArray];
    let value_type = list[mainindex]["emomSets"][detailsData][exerIndex];
    value_type["exercise"] = value;
    value_type["description"] = value?.instructions;
    value_type["open"] = true;

    setaddArray(list);
    setModalChangeExe(true);
    if (isWithHistoryAndBigScreen) {
      handleHistoryOFAnExercise(value, mainindex, detailsData, exerIndex);
    }
  };

  const handleHistorySuperset = async (value, mainIndex, exerInde) => {
    setDetailsData(mainIndex);
    setExerIndex(exerInde);
    let postData = {
      exercise: value?._id,
      member: memberId,
    };
    setHistoryModalData([]);
    setIsLoading(true);
    try {
      let result = await programme_workout_exercise_history_list_api(postData);
      if (result.code == 200) {
        if (!result.exercise_history.length > 0) {
          const list = [...addArray];
          delete list[mainindex]["emomSets"][detailsData][exerIndex]["history"];
          setaddArray(list);
          return;
        }
        let givenExercise = result.exercise_history.map((item) => {
          return exercise_history(item);
        });
        setHistoryModalData(givenExercise);
        const list = [...addArray];
        list[mainindex]["emomSets"][detailsData][exerIndex]["history"] =
          givenExercise;
        setaddArray(list);
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
      setHistoryModalOpenSuperset(true);
    }
  };

  const handleHistorySupersetOpen = async (value, mainIndex, exerInde) => {
    setDetailsData(mainIndex);
    setExerIndex(exerInde);
    handleHistorySuperset(value.exercise, mainIndex, exerInde);
  };

  const handleHistoryPreviousOpen = async (value) => {
    setSelectedExercise(value?.exercise?._id);
    setUserExerciseHistoryLoading(true);
    setUserExerciseHistory(value?.history);
    setUserExerciseHistoryLoading(false);
  };

  const handleParametersSuperset = (main, inr) => {
    setModalOpen(true);
    setModalOpenForSuperset(true);
    setOuterIndex(main);
    setExerIndex(inr);
    setExsrInfo(addArray[mainindex].emomSets[main][inr].parameters);
  };

  const handleChangeParametersInsetFieldValueSuperSet = (
    value,
    outerIndex,
    exerIndex,
  ) => {
    const items = Array.from(addArray);

    const sets = handle_change_parameters(
      items,
      items[mainindex].emomSets[outerIndex][exerIndex].parameters,
      items[mainindex].emomSets[outerIndex][exerIndex].set,
    );

    items[mainindex].emomSets[outerIndex][exerIndex].set = sets;
    setaddArray(items);
  };

  const handleChangeParametersInsetFieldValue = (value, outerIndex) => {
    const items = Array.from(addArray);

    const sets = handle_change_parameters(
      items,
      items[outerIndex].parameters,
      items[outerIndex].set,
    );

    items[outerIndex].set = sets;
    setaddArray(items);
  };

  const handleChangeParametersInset = (value) => {
    const items = Array.from(addArray);
    if (modalOpenForSuperset) {
      items[mainindex].emomSets[outerIndex][exerIndex].parameters = value;
      setExsrInfo(items[mainindex].emomSets[outerIndex][exerIndex].parameters);
      setaddArray(items);
      setModalChangeExe(true);
      handleChangeParametersInsetFieldValueSuperSet(
        value,
        outerIndex,
        exerIndex,
      );
      return;
    }
    items[outerIndex].parameters = value;
    setExsrInfo(items[outerIndex].parameters);
    setaddArray(items);
    setModalChangeExe(true);
    handleChangeParametersInsetFieldValue(value, outerIndex);
  };

  const memueOptions1 = (index, value) => {
    const MENU_OPTIONS = [];
    MENU_OPTIONS.unshift(
      {
        label: "Move Up",
        icon: "mdi:arrow-up",
        handleClick: handleChangeUpMoment,
        disabled: value == 0 ? true : false,
      },
      {
        label: "Move Down",
        icon: "ic:outline-arrow-downward",
        handleClick: handleChangeDownMoment,
        disabled:
          value >= addArray[mainindex]["emomSets"][index].length - 1
            ? true
            : false,
      },
    );

    return MENU_OPTIONS;
  };

  const handleMinutesChangeSets = (e, index, exerIndex, setIndex) => {
    const { name, value } = e.target;
    const list = [...addArray];
    const minutes = parseInt(e.target.value) || 0;
    const seconds =
      list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex][name] % 60;
    updateIntervalTimeSets(minutes, seconds, index, exerIndex, setIndex, name);
  };

  const handleSecondsChangeSets = (e, index, exerIndex, setIndex) => {
    const { name, value } = e.target;
    const list = [...addArray];

    let seconds = parseInt(e.target.value) || 0;
    seconds = Math.min(Math.max(seconds, 0), 59);
    const minutes = Math.floor(
      list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex][name] / 60,
    );
    updateIntervalTimeSets(minutes, seconds, index, exerIndex, setIndex, name);
  };

  const updateIntervalTimeSets = (
    minutes,
    seconds,
    index,
    exerIndex,
    setIndex,
    name,
  ) => {
    const totalSeconds = minutes * 60 + seconds;
    const list = [...addArray];
    list[mainindex]["emomSets"][index][exerIndex]["set"][setIndex][name] =
      totalSeconds;
    setaddArray(list);
    setModalChangeExe(true);
  };

  const handleClickOpen = async (exercise) => {
    setSingleExerciseInfo(exercise);
    setOpenSingleExerciseInfo(true);
  };

  return (
    <div className="my-2">
      <ModalsManager
        isLoading={isLoading}
        classes={classes}
        openPaceAlert={openPaceAlert}
        setOpenPaceAlert={setOpenPaceAlert}
        openSingleExerciseInfo={openSingleExerciseInfo}
        setOpenSingleExerciseInfo={setOpenSingleExerciseInfo}
        singleExerciseInfo={singleExerciseInfo}
        openDetails={openDetails}
        setOpenDetails={setOpenDetails}
        handleSelectExercise={handleSelectExercise}
        isExerciseForSuperSet={isExerciseForSuperSet}
        setIsExerciseForSuperSet={setIsExerciseForSuperSet}
        isWithHistory={isWithHistory}
        handleSelectSupersetExerciseSingle={handleSelectSupersetExerciseSingle}
        handleSelectSupersetExercise={handleSelectSupersetExercise}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        exerInfo={exerInfo}
        handleChangeParametersInset={handleChangeParametersInset}
        addArray={addArray}
        historyModalOpen={historyModalOpen}
        setHistoryModalOpen={setHistoryModalOpen}
        historyModalOpenSuperset={historyModalOpenSuperset}
        setHistoryModalOpenSuperset={setHistoryModalOpenSuperset}
        historyModalData={historyModalData}
        setHistoryModalData={setHistoryModalData}
        handleCopyExercise={handleCopyExercise}
        handleCopySupersetExercise={handleCopySupersetExercise}
      />
      {paceModalOpen && member_vdot && (
        <Dialog
          open={paceModalOpen}
          onClose={() => setPaceModalOpen(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            style: {
              backgroundColor: "white",
              color: "black",
              boxShadow: "none",
            },
          }}
        >
          <div className="text-end mt-1 d-flex justify-content-between align-items-center">
            <DialogTitle
              sx={{
                paddingY: 0,
                color: get_root_value("--portal-theme-primary"),
              }}
            >
              Pace Calculator
            </DialogTitle>
            <IconButton
              className="back-screen-button me-1"
              onClick={() => setPaceModalOpen(false)}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <DialogContent>
            <PaceCalculator
              checkedPace={!!member_vdot}
              memberVdotData={memberVdotData}
              setMemberVdotDataData={setMemberVdotDataData}
              member_vdot={member_vdot}
              member_vdot_info={member_vdot_info}
            />
          </DialogContent>
        </Dialog>
      )}
      <div className="mt-2 ">
        <div className="characters">
          <form onSubmit={() => {}}>
            <div
              style={{ position: "relative" }}
              className="workout-Superset-card my-1"
            >
              <Box>
                <div className="row mb-3">
                  <div
                    className={`col-sm-12 col-md-2 col-lg-2 order-2 order-md-1 text-center text-md-start`}
                  >
                    <TextField
                      id="outlined-basic"
                      variant="outlined"
                      label="Interval Duration"
                      InputLabelProps={{
                        className: "textfiels-input-label",
                        shrink: true,
                        style: { fontSize: "14px" },
                      }}
                      InputProps={{
                        className: "textfiels-input-value",
                        style: {
                          fontSize: "13px",
                          paddingLeft: "0px",
                          paddingRight: "0px",

                          justifyContent: "center",
                        },
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <TextField
                              id="outlined-basic-minutes"
                              type="number"
                              size="small"
                              placeholder="Min"
                              value={formatWithLeadingZeros(
                                Math.floor(
                                  addArray[mainindex].time_interval / 60,
                                ),
                              )}
                              onChange={handleMinutesChange}
                              InputProps={{
                                className: "textfiels-input-value",
                                style: {
                                  fontSize: "19px",
                                  fontWeight: "500",
                                },
                              }}
                              sx={{
                                "& fieldset": {
                                  border: "none",
                                },
                                "& input": {
                                  textAlign: "center",
                                  padding: "0px",
                                },
                                width: "100%",
                              }}
                            />
                            <div className="fs-4 fw-semibold ">:</div>

                            <TextField
                              id="outlined-basic-seconds"
                              type="number"
                              size="small"
                              placeholder="Sec"
                              value={formatWithLeadingZeros(
                                addArray[mainindex].time_interval % 60,
                              )}
                              onChange={handleSecondsChange}
                              InputProps={{
                                className: "textfiels-input-value",
                                style: {
                                  fontSize: "19px",
                                  fontWeight: "500",
                                },
                              }}
                              sx={{
                                "& fieldset": {
                                  border: "none",
                                },
                                "& input": {
                                  textAlign: "center",
                                  padding: "0px",
                                },
                                width: "100%",
                              }}
                            />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        borderRadius: "5px",
                        fontSize: "13px",
                        "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                          {
                            width: "0px !important",
                            padding: "9px 0px !important",
                          },
                        "& .css-1nuss9t": {
                          width: "0px !important",
                          padding: "9px 0px !important",
                        },

                        width: "110px",
                      }}
                    />
                  </div>
                  <div
                    className={`col-sm-12 col-md-8 col-lg-8 order-3 order-md-2`}
                  >
                    <div
                      className={`${
                        smallScreen
                          ? "my-2 text-center"
                          : "d-flex align-items-center justify-content-center my-2"
                      }`}
                    >
                      <div style={{ whiteSpace: "nowrap" }}>
                        Every {getMinutesForEmom()} minutes{" "}
                      </div>
                      <div className="d-flex align-items-center justify-content-center  ">
                        <div className="ms-2 cross-icon ">
                          <RemoveCircleIcon
                            onClick={() => handleMinusSetCount(mainindex)}
                            className="diary-icon-plus-minus"
                          />
                        </div>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder="Rounds"
                          type="number"
                          value={addArray[mainindex].rounds}
                          name="superset_sets"
                          disabled
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: { fontSize: "14px" },
                          }}
                          InputProps={{
                            className: "textfiels-input-value",
                            style: { fontSize: "13px", padding: "0" },
                          }}
                          sx={{
                            mx: 1,
                            borderRadius: "5px",
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            fontSize: "13px",
                            "& input": {
                              padding: "3px 5px",
                              textAlign: "center",
                            },
                            width: "33px",
                          }}
                        />

                        <div className=" cross-icon me-2">
                          <AddCircleIcon
                            onClick={() => handleAddSetCount(mainindex)}
                            className="diary-icon-plus-minus"
                          />
                        </div>
                        <div>rounds</div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-2 col-lg-2  cross-icon order-1 order-md-3 d-flex justify-content-end">
                    <Tooltip title="Remove Exercise">
                      <RemoveCircleOutlineIcon
                        onClick={() => handleDelete(mainindex)}
                        className="diary-icon-remove"
                      />
                    </Tooltip>
                    <Tooltip title="Add Exercise">
                      <AddCircleOutlineIcon
                        onClick={() => handleAdd(mainindex)}
                        className="diary-icon-add"
                      />
                    </Tooltip>
                    <CustomPopoverSection
                      menu={memueOptions(mainindex)}
                      data={mainindex}
                    />
                  </div>
                </div>
                <TextField
                  id="outlined-basic"
                  size="small"
                  variant="outlined"
                  placeholder="Instructions"
                  label="Instructions"
                  type="number"
                  value={addArray[mainindex].description}
                  name="description"
                  multiline
                  rows={2}
                  onChange={(e) => handleChangeDes(e, mainindex)}
                  InputLabelProps={{
                    className: "textfiels-input-label",
                    shrink: true,
                    style: { fontSize: "14px" },
                  }}
                  InputProps={{
                    className: "textfiels-input-value",
                    style: { fontSize: "14px" },
                  }}
                  sx={{
                    borderRadius: "5px",
                    mt: 2,
                    width: "100%",
                  }}
                />
                {addArray[mainindex].emomSets.length > 0 &&
                  addArray[mainindex].emomSets.map((item, index) => {
                    return (
                      <div className="my-2">
                        <div className="d-flex justify-content-between align-items-center ">
                          <div>Minute {getMinutesForInterval(index)}</div>
                          <Tooltip
                            title={`${
                              addArray[mainindex].emomSets.length > 1
                                ? "Delete"
                                : "Can't be Deleted"
                            }`}
                          >
                            <DeleteIcon
                              className={`${
                                addArray[mainindex].emomSets.length > 1
                                  ? "del-icon-calendar-workout-working"
                                  : "del-icon-calendar-workout-notwork"
                              }`}
                              onClick={
                                addArray[mainindex].emomSets.length > 1
                                  ? () => handleDeleteInterval(mainindex, index)
                                  : () => {}
                              }
                            />
                          </Tooltip>
                        </div>
                        {item.length > 0 &&
                          item.map((exerData, exerIndex) => {
                            return (
                              <CustomFeilds
                                addArray={addArray}
                                memueOptions1={memueOptions1}
                                index={index}
                                exerIndex={exerIndex}
                                exerData={exerData}
                                handleArrowSuperSet={handleArrowSuperSet}
                                handleParametersSuperset={
                                  handleParametersSuperset
                                }
                                isWithHistoryAndBigScreen={
                                  isWithHistoryAndBigScreen
                                }
                                isHistory={isHistory}
                                isSidebar={isSidebar}
                                handleChangeEmomSet={handleChangeEmomSet}
                                handleChangeEmomSetTempo={
                                  handleChangeEmomSetTempo
                                }
                                handleChangeVdotDistance={
                                  handleChangeVdotDistance
                                }
                                handleChangeVdotPaceType={
                                  handleChangeVdotPaceType
                                }
                                handleClickOpen={handleClickOpen}
                                handleDeleteIntervalExercise={
                                  handleDeleteIntervalExercise
                                }
                                handleHistoryPreviousOpen={
                                  handleHistoryPreviousOpen
                                }
                                handleHistorySupersetOpen={
                                  handleHistorySupersetOpen
                                }
                                handleMinutesChange={handleMinutesChange}
                                handleMinutesChangeSets={
                                  handleMinutesChangeSets
                                }
                                handleSupersetExerciseList={
                                  handleSupersetExerciseList
                                }
                                memberId={memberId}
                                handleSecondsChangeSets={
                                  handleSecondsChangeSets
                                }
                                selectedExercise={selectedExercise}
                                handleSecondsChange={handleSecondsChange}
                                member_vdot={member_vdot}
                                setPaceModalOpen={setPaceModalOpen}
                              />
                            );
                          })}

                        <div
                          className="d-flex align-items-center ms-4 set-parameters mt-1 "
                          onClick={() => {
                            handleAddMoment(index, exerIndex);
                          }}
                        >
                          <AddCircleIcon />
                          <Typography variant="body2" sx={{ ml: 0.2 }}>
                            {`Add Movement`}
                          </Typography>
                        </div>
                      </div>
                    );
                  })}
                <div className="text-center container my-2">
                  <button
                    className="small-contained-button "
                    onClick={(e) => {
                      handleAddInterval(e);
                    }}
                  >
                    Add interval
                  </button>
                </div>
              </Box>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default EMOMExercisesUI;
